/**
 * DealViabilityMark
 *
 * The tick at the right edge of the offer amount field — the top state in both columns: at or
 * above the customer's floor price where it is shared, and where the odds have reached the top
 * of the fitted curve where it is not.
 *
 * Separate from `DealViabilityInsight` because it belongs in a different place: the tranches
 * that have something to say render a card beneath the field, this one sits on it.
 *
 * It is deliberately wordless. Anything it said would state that the floor price has been
 * cleared, which hands the investor a bar to come back down to.
 */

import type { OfferViability } from '@/features/offers/api/offers'
import * as styles from './DealViabilityMark.css'

export interface DealViabilityMarkProps {
  /** Server response, or undefined while it has not been fetched. */
  insight?: OfferViability | null
}

export function DealViabilityMark({ insight }: DealViabilityMarkProps) {
  if (!insight?.show || insight.tier !== 't3') return null

  return (
    <span
      className={styles.mark}
      role="status"
      aria-label="Good offer amount"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    </span>
  )
}
